export default "<app-nav></app-nav>\n<div>\n    <router-outlet></router-outlet>\n</div>\n"